import { zapiPlayOptions } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayRecording = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getPlayerZapi();
    return player.playRecording(parameters.id, zapiPlayOptions(parameters.options));
};
